import { render, staticRenderFns } from "./ftpData.vue?vue&type=template&id=6323bfd3&scoped=true&"
import script from "./ftpData.vue?vue&type=script&lang=js&"
export * from "./ftpData.vue?vue&type=script&lang=js&"
import style0 from "./ftpData.vue?vue&type=style&index=0&id=6323bfd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323bfd3",
  null
  
)

export default component.exports